import throttle from 'lodash.throttle';
import debounce from 'lodash.debounce';
let $fadeUpElements = [];
let initialized = false;
const options = {
    offset: 120,
    delay: 100,
    easing: 'ease-in-out',
    duration: 600,
    once: false,
    startEvent: 'DOMContentLoaded',
    throttleDelay: 99,
    debounceDelay: 50,
};
let callback = () => { };
const containsFadeUpNode = (nodes) => {
    for (const node of nodes) {
        if (node instanceof HTMLElement && node.dataset && node.dataset.fadeUp) {
            return true;
        }
        if (node instanceof HTMLElement && node.children && containsFadeUpNode(Array.from(node.children))) {
            return true;
        }
    }
    return false;
};
const getMutationObserver = () => window.MutationObserver;
const ready = (selector, fn) => {
    const doc = window.document;
    const MutationObserver = getMutationObserver();
    const observer = new MutationObserver(check);
    callback = fn;
    observer.observe(doc.documentElement, {
        childList: true,
        subtree: true
    });
};
const check = (mutations) => {
    if (!mutations)
        return;
    mutations.forEach(mutation => {
        const addedNodes = Array.from(mutation.addedNodes);
        const removedNodes = Array.from(mutation.removedNodes);
        const allNodes = addedNodes.concat(removedNodes);
        if (containsFadeUpNode(allNodes)) {
            return callback();
        }
    });
};
const setState = (el, top, once) => {
    const attrOnce = el.node.getAttribute('data-fade-up-once');
    if (top > el.position) {
        el.node.classList.add('fade-up-animate');
    }
    else if (attrOnce !== undefined) {
        if (attrOnce === 'false' || (!once && attrOnce !== 'true')) {
            el.node.classList.remove('fade-up-animate');
        }
    }
};
const handleScroll = ($elements, once) => {
    const scrollTop = window.pageYOffset;
    const windowHeight = window.innerHeight;
    $elements.forEach(el => {
        setState(el, windowHeight + scrollTop, once);
    });
};
const createArrayWithElements = (elements = document.querySelectorAll('[data-fade-up]')) => {
    return Array.from(elements, node => ({ node }));
};
const offset = (el) => {
    let _x = 0;
    let _y = 0;
    while (el && !isNaN(el.offsetLeft) && !isNaN(el.offsetTop)) {
        _x += el.offsetLeft - (el.tagName !== 'BODY' ? el.scrollLeft : 0);
        _y += el.offsetTop - (el.tagName !== 'BODY' ? el.scrollTop : 0);
        el = el.offsetParent;
    }
    return { top: _y, left: _x };
};
const calculateOffset = (el, optionalOffset) => {
    let elementOffsetTop = 0;
    let additionalOffset = 0;
    const windowHeight = window.innerHeight;
    const attrs = {
        offset: el.getAttribute('data-fade-up-offset'),
        anchor: el.getAttribute('data-fade-up-anchor'),
        anchorPlacement: el.getAttribute('data-fade-up-anchor-placement')
    };
    if (attrs.offset && !isNaN(Number(attrs.offset))) {
        additionalOffset = parseInt(attrs.offset);
    }
    if (attrs.anchor && document.querySelector(attrs.anchor)) {
        el = document.querySelector(attrs.anchor);
    }
    elementOffsetTop = offset(el).top;
    if (attrs.anchorPlacement === 'center-bottom') {
        elementOffsetTop += el.offsetHeight / 2;
    }
    if (!attrs.anchorPlacement && !attrs.offset && !isNaN(optionalOffset)) {
        additionalOffset = optionalOffset;
    }
    return elementOffsetTop + additionalOffset;
};
const prepare = ($elements, options) => {
    $elements.forEach(el => {
        el.node.classList.add('fade-up-init');
        el.position = calculateOffset(el.node, options.offset);
    });
    return $elements;
};
const refresh = (initialize = false) => {
    if (initialize)
        initialized = true;
    if (initialized) {
        $fadeUpElements = prepare($fadeUpElements, options);
        handleScroll($fadeUpElements, options.once);
        return $fadeUpElements;
    }
};
const init = (settings) => {
    Object.assign(options, settings);
    $fadeUpElements = createArrayWithElements();
    const body = document.querySelector('body');
    body.setAttribute('data-fade-up-easing', options.easing);
    body.setAttribute('data-fade-up-duration', options.duration.toString());
    body.setAttribute('data-fade-up-delay', options.delay.toString());
    const startEvent = options.startEvent;
    if (startEvent === 'DOMContentLoaded' && ['complete', 'interactive'].includes(document.readyState)) {
        refresh(true);
    }
    else {
        window.addEventListener(startEvent, () => refresh(true));
    }
    window.addEventListener('resize', debounce(() => refresh(), options.debounceDelay, true));
    window.addEventListener('orientationchange', debounce(() => refresh(), options.debounceDelay, true));
    window.addEventListener('scroll', throttle(() => handleScroll($fadeUpElements, options.once), options.throttleDelay));
    return $fadeUpElements;
};
init();
export { init, refresh };
